import { CommunicationService } from './../../common/communication.service';
import { LocalDBService } from './../../service/local-db.service';
import { DashboardViewSelection } from './../../dashboard/dashboard-view-selection';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AwsUtil } from '../../authentication/aws.service';
import { AppConfig } from './../../app.config';
import {
    WebApiEndpoints,
    GetReportDashboardQueryDataRequest,
    GetReportDashboardQueryDataResult,
    ReportDashboardQueryRequest,
    GetALMAdhocQueryStateResult,
    GetALMAdhocQueryStateRequest
} from '@liquitics/transaction';
import {
    convertFromConstantToHuman,
} from '@liquitics/transaction';
import {
    ALMBreakDownData,
    ALMMetricValueRollupType,
} from '@liquitics/transaction';
import { MatDialog } from '@angular/material/dialog';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { TreeNode, SelectItem } from 'primeng/api';
import { walkAndBuildTreeNode } from '../alm-dashboard';
import { SnapshotService } from '../../snapshot/snapshot.service';
import { ReportDashboardQueryRequestComponent } from '../../report-dashboard/query-request/report-dashboard-query-request.component';


class ShowBreakDownData {
    rootNode = {} as TreeNode;
    rollUpTypes: ALMMetricValueRollupType[] = [];
    numeratorFieldNames: string[] = [];
    denominatorFieldNames: string[] = [];
    levels: string[] = [];
    adhocQueryTreeNodes: TreeNode[];
    originalBreakDownColumnNames: string[];
    originalLadderColumnNames: string[];
    breakDownColumnNames: string[];
    ladderColumnNames: string[];
    breakDownData: ALMBreakDownData[];
}

class PieOptions {
    dataUsage: 'ABS' | 'POSITIVE' | 'NEGATIVE' = 'ABS';
    dataUsageOptions = [
        { label: 'Absolute value', value: 'ABS' },
        { label: 'Positive only', value: 'POSITIVE' },
        { label: 'Negative only', value: 'NEGATIVE' }
    ]
}

@Component({
    selector: 'app-alm-adhoc',
    templateUrl: './alm-adhoc.component.html',
    styleUrls: ['./alm-adhoc.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ALMAdhocComponent implements OnInit, OnDestroy {
    isTopExpanded: boolean;
    runningRefresh: boolean;
    showInProgress: boolean;
    subscription: Subscription;
    queries: any[];
    selectedQuery: any;
    queryStateResult: GetALMAdhocQueryStateResult;
    chart: am4charts.Chart;
    displayType = 'PIE';
    displayTypeOptions: SelectItem[];
    attributeColumnOptions: SelectItem[];
    valueColumnOptions: SelectItem[];
    chartPrimaryAttributeColumn: string;
    chartSecondaryAttributeColumn: string;
    chartPrimaryValueColumn: string;
    sortByOptions: SelectItem[];
    selectedSortByOption = 'CATEGORY';
    sortDirectionOptions: SelectItem[];
    selectedSortDirectionOption = 'ASCENDING';

    pieOptions = new PieOptions();
    showBreakDownData: ShowBreakDownData;
    currentQueryDataResult: GetReportDashboardQueryDataResult;

    downloadColumns: any[];
    downloadData: any[];

    batchIdentifier: string;

    constructor(
        private awsUtil: AwsUtil,
        private dashboardEventService: DashboardEventService,
        private localDBService: LocalDBService,
        private communicationService: CommunicationService,
        private dialog: MatDialog,
        private snapshotService: SnapshotService) {
        this.isTopExpanded = true;
        this.displayTypeOptions = [
            { label: 'Pie', value: 'PIE', icon: 'pi pi-circle-on' },
            { label: 'Bar', value: 'BAR', icon: 'pi pi-chart-bar' },
            { label: 'Break Down', value: 'BREAKDOWN', icon: 'pi pi-sitemap' },
        ];
        this.sortByOptions = [
            { label: 'Category', value: 'CATEGORY' },
            { label: 'Value', value: 'VALUE' },
        ];
        this.sortDirectionOptions = [
            { label: 'Ascending', value: 'ASCENDING', icon: 'fa fa-sort-amount-asc' },
            { label: 'Descending', value: 'DESCENDING', icon: 'fa fa-sort-amount-desc' },
        ];
    }
    ngOnInit() {
        this.batchIdentifier = this.snapshotService.getDefaultBatchIdentifier();
        this.refreshQueryState();
    }

    refreshQueryState() {
        this.runningRefresh = true;
        this.awsUtil.webAPICall<GetALMAdhocQueryStateResult>(WebApiEndpoints.QueryALMAdhocState,
            {
                batchIdentifier: this.batchIdentifier,
            } as GetALMAdhocQueryStateRequest)
            .then((result: GetALMAdhocQueryStateResult) => {
                this.queryStateResult = result;
                this.queries = result.queries;
                this.runningRefresh = false;
                this.selectedQuery = undefined;
            })
            .catch(() => {
                this.runningRefresh = false;
            });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    refreshState() {
        this.refreshQueryState();
    }

    openNewQuery() {
        setTimeout(() => {
            const dialogRef = this.dialog.open(ReportDashboardQueryRequestComponent, {
                width: '50%',
                height: '80%',
                data: {
                    attributeColumns: this.queryStateResult.availableTradeAttributeColumns,
                    valueColumns: this.queryStateResult.availableTradeValueColumns,
                    batchIdentifier: this.batchIdentifier,
                    configuration: {
                        type: 'TRADE',
                        usage: 'DOWNLOAD',
                        sourceFilters: [],
                        resultFilters: [],
                        sortDescending: false,
                        useAbsoluteValue: false,
                    } as ReportDashboardQueryRequest,
                    title: 'ALM Adhoc Query Request',
                    okButtonLabel: 'Submit',
                    showQueryUsage: true,
                    showUseAbsoluteValue: true,
                    showIncludeCount: true,
                }
                // data: {
                //     attributeColumns: ['aaa', 'bbb', 'ccc', 'ddd'],
                //     valueColumns: ['111', '222', '333'],
                // }
            });
            dialogRef.afterClosed().toPromise()
                .then((queryRequest: any) => {
                    if (queryRequest) {
                        this.awsUtil.webAPICall<string>(WebApiEndpoints.SubmitALMAdhocQuery, queryRequest, true)
                            .catch((err) => {
                                console.log(`Error while calling SubmitReportDashboardQuery: ${err}`);
                                this.communicationService.openSnackBar(`Failed to submit Adhoc query: ${err.error}`, 'Dismiss');
                            });
                        this.refreshQueryState();
                    }
                });
        }, 10);
    }

    generateSelectedQueryCacheKey(): string {
        const cacheKey = `${this.batchIdentifier}-${this.selectedQuery.name}`;
        return cacheKey;
    }

    downloadSelected(): Promise<GetReportDashboardQueryDataResult> {
        const cacheKey = this.generateSelectedQueryCacheKey();
        let cachedResult = this.localDBService.getRegisteredPromise<GetReportDashboardQueryDataResult>(cacheKey);
        if (!cachedResult) {
            cachedResult = this.awsUtil.webAPICall<GetReportDashboardQueryDataResult>(WebApiEndpoints.QueryReportDashboardData,
                {
                    queryName: this.selectedQuery.name,
                    batchIdentifier: this.batchIdentifier,
                } as GetReportDashboardQueryDataRequest);
        }
        this.localDBService.registerPromise(cacheKey, cachedResult);
        return cachedResult;
    }

    showSelected() {
        this.showInProgress = true;
        const cachedResult = this.downloadSelected();
        cachedResult
            .then((result: GetReportDashboardQueryDataResult) => {
                if (result.errorMessage) {
                    this.communicationService.openSnackBar(`Failed to download data: ${result.errorMessage}`, 'Dismiss');
                    const cacheKey = this.generateSelectedQueryCacheKey();
                    this.localDBService.unregisterPromise(cacheKey);
                } else {
                    this.currentQueryDataResult = result;
                    if (this.chart) {
                        this.chart.dispose();
                    }
                    this.chart = undefined;
                    this.showBreakDownData = undefined;
                    if (this.selectedQuery.usage === 'GRAPHICAL') {
                        this.attributeColumnOptions = this.columnsToOptions(this.currentQueryDataResult.attributeColumns);
                        this.valueColumnOptions = this.columnsToOptions(this.currentQueryDataResult.valueColumns);
                        this.chartPrimaryAttributeColumn = this.currentQueryDataResult.attributeColumns[0];
                        this.chartPrimaryValueColumn = this.currentQueryDataResult.valueColumns[0];
                        this.showGraphical();
                    } else if (this.selectedQuery.usage === 'DOWNLOAD') {
                        this.downloadColumns = [...result.attributeColumns, ...result.valueColumns]
                            .map((col) => {
                                return { field: col, header: col };
                            });
                        this.downloadData = result.data;
                    }
                }
                this.showInProgress = false;
                this.isTopExpanded = false;
            })
            .catch((err) => {
                const cacheKey = this.generateSelectedQueryCacheKey();
                this.localDBService.unregisterPromise(cacheKey);
                this.showInProgress = false;
                this.communicationService.openSnackBar(`Failed to retrieve data: ${err.error}`, 'Dismiss');
            });
    }

    rebuildGraphicalData(): any[] {
        const filterAndMappedData = this.currentQueryDataResult.data
            .filter((d: any) => {
                if (this.displayType === 'PIE') {
                    if (this.pieOptions.dataUsage === 'POSITIVE') {
                        return d[this.chartPrimaryValueColumn] > 0
                    } else if (this.pieOptions.dataUsage === 'NEGATIVE') {
                        return d[this.chartPrimaryValueColumn] < 0
                    }
                }
                return true;
            })
            .map((d: any) => {
                let value = d[this.chartPrimaryValueColumn];
                if (this.displayType === 'PIE') {
                    value = Math.abs(value);
                }
                return {
                    [this.chartPrimaryAttributeColumn]: d[this.chartPrimaryAttributeColumn],
                    [this.chartPrimaryValueColumn]: value,
                };
            })
            ;
        const groupedData = filterAndMappedData
            .reduce((grouped, d) => {
                const key = d[this.chartPrimaryAttributeColumn];
                if (!key) {
                    // Prevent undefined nodes
                    return grouped;
                }
                grouped[key] = grouped[key] || [];
                grouped[key].push(d);
                return grouped;
            }, {});
        const data = Object.keys(groupedData)
            .map((key: string) => {
                return groupedData[key]
                    .reduce((running, d) => {
                        running[this.chartPrimaryValueColumn] += d[this.chartPrimaryValueColumn];
                        return running;
                    });
            })
            .sort((d1, d2) => {
                let retVal;
                if (this.selectedSortByOption === 'CATEGORY') {
                    retVal = d1[this.chartPrimaryAttributeColumn] > d2[this.chartPrimaryAttributeColumn] ? -1 : 1;
                } else {
                    retVal = d1[this.chartPrimaryValueColumn] > d2[this.chartPrimaryValueColumn] ? -1 : 1;
                }
                if (this.selectedSortDirectionOption === 'DESCENDING') {
                    retVal *= -1;
                }
                return retVal;
            });
        return data;
    }



    showGraphical() {
        if (this.chart) {
            this.chart.dispose();
        }
        let chart;
        if (this.displayType === 'PIE') {
            chart = am4core.create('chartdiv', am4charts.PieChart);
            chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
            chart.data = this.rebuildGraphicalData();
            chart.logo.visible = false;
            chart.innerRadius = 100;

            const series = chart.series.push(new am4charts.PieSeries3D());
            series.dataFields.category = this.chartPrimaryAttributeColumn;
            series.dataFields.value = this.chartPrimaryValueColumn;
        } else if (this.displayType === 'BAR') {
            chart = am4core.create('chartdiv', am4charts.XYChart);
            chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
            chart.data = this.rebuildGraphicalData();
            chart.logo.visible = false;

            const yAxis = chart.yAxes.push(new am4charts.CategoryAxis());
            yAxis.dataFields.category = this.chartPrimaryAttributeColumn;
            yAxis.renderer.grid.template.location = 0;
            yAxis.renderer.labels.template.fontSize = 10;
            yAxis.renderer.minGridDistance = 10;

            const xAxis = chart.xAxes.push(new am4charts.ValueAxis());

            const series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryY = this.chartPrimaryAttributeColumn;
            series.dataFields.valueX = this.chartPrimaryValueColumn;
            // Add distinctive colors for each column using adapter
            series.columns.template.adapter.add('fill', (fill, target) => {
                return chart.colors.getIndex(target.dataItem.index);
            });
        } else if (this.displayType === 'INVESTIGATION') {
            this.showBreakDown(this.currentQueryDataResult);
        }
        // } else if (this.displayType === 'SCATTER') {
        //     chart = am4core.create('chartdiv', am4charts.XYChart);
        //     chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
        //     chart.data = this.currentQueryDataResult.data;
        //     chart.logo.visible = false;

        //     const yAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        //     yAxis.dataFields.category = this.chartPrimaryAttributeColumn;
        //     yAxis.renderer.grid.template.location = 0;
        //     yAxis.renderer.labels.template.fontSize = 10;
        //     yAxis.renderer.minGridDistance = 10;

        //     const xAxis = chart.xAxes.push(new am4charts.ValueAxis());

        //     const series = chart.series.push(new am4charts.XYSeries());
        //     series.dataFields.categoryY = this.chartPrimaryAttributeColumn;
        //     series.dataFields.valueX = this.chartPrimaryValueColumn;
        //     // Add distinctive colors for each column using adapter
        //     series.columns.template.adapter.add('fill', (fill, target) => {
        //         return chart.colors.getIndex(target.dataItem.index);
        //     });
        this.chart = chart;
    }


    displayTypeChanged() {
        this.showGraphical();
    }

    chartOptionsChanged() {
        this.showGraphical();
    }

    showBreakDown(result: GetReportDashboardQueryDataResult) {
        this.showBreakDownData = new ShowBreakDownData();
        this.showBreakDownData.breakDownData = result.data
            .map((d) => {
                const bdd = {
                } as ALMBreakDownData;
                result.attributeColumns
                    .forEach((attributeColumn: string, index: number) => {
                        bdd[`bd${index + 1}`] = d[attributeColumn];
                    });
                result.valueColumns
                    .forEach((valueColumn: string, index: number) => {
                        bdd[`ln${index + 1}`] = d[valueColumn];
                        bdd[`ld${index + 1}`] = 1.0;
                    });
                return bdd;
            });

        this.showBreakDownData.originalBreakDownColumnNames = [...result.attributeColumns];
        this.showBreakDownData.originalLadderColumnNames = [...result.valueColumns];
        this.showBreakDownData.breakDownColumnNames = [...result.attributeColumns];
        this.showBreakDownData.ladderColumnNames = [...result.valueColumns];
        this.rebuildBreakDown();
    }

    rebuildBreakDown() {
        this.showBreakDownData.levels = [];
        this.showBreakDownData.rollUpTypes = [];
        this.showBreakDownData.numeratorFieldNames = [];
        this.showBreakDownData.denominatorFieldNames = [];
        this.showBreakDownData.breakDownColumnNames
            .forEach((attributeColumn: string) => {
                const index = this.showBreakDownData.originalBreakDownColumnNames.indexOf(attributeColumn);
                this.showBreakDownData.levels.push(`bd${index + 1}`);
            });
        this.showBreakDownData.ladderColumnNames
            .forEach((valueColumn: string) => {
                const index = this.showBreakDownData.originalLadderColumnNames.indexOf(valueColumn);
                this.showBreakDownData.rollUpTypes.push('COUNT');
                this.showBreakDownData.numeratorFieldNames.push(`ln${index + 1}`);
                this.showBreakDownData.denominatorFieldNames.push(`ld${index + 1}`);
            });
        walkAndBuildTreeNode(this.showBreakDownData.rollUpTypes, this.showBreakDownData.rootNode, this.showBreakDownData.breakDownData,
            this.showBreakDownData.numeratorFieldNames, this.showBreakDownData.denominatorFieldNames,
            this.showBreakDownData.levels, -1, '');
        this.showBreakDownData.adhocQueryTreeNodes = this.showBreakDownData.rootNode.children;
        this.showBreakDownData.rootNode.children
            .forEach((node: TreeNode) => {
                node.expanded = false;
            });
    }

    adhocNodeSelected(event) {

    }

    columnToDisplay(columnName: string): string {
        return convertFromConstantToHuman(columnName);
    }

    columnsToOptions(columnNames: string[]): SelectItem[] {
        return columnNames
            .map((columnName) => {
                return {
                    label: convertFromConstantToHuman(columnName),
                    value: columnName
                } as SelectItem;
            });
    }

}
